const Regex = {
  password: /^((?=.*[\W])|(?=.*[A-Za-z]))(?=.*\d).{8,32}$/,
  phoneNo: /^[0-9]{8,10}$/, // ori: /^(1)[0-9]{8,9}$/
  phoneNoSG: /^[0-9]{8,11}$/,
  alphabetOnly: /^[a-zA-Z\s]+$/,
  numberOnly: /^[0-9]+$/,
  alphabetNumber: /^[A-Za-z0-9]+$/,
  noSymbolEmoji: /^(?![\s]+$)[A-Za-z0-9\s.\u3000\u3400-\u4DBF\u4E00-\u9FFF\u2A700–\u2B73F\u2B740–\u2B81F\u2B820–\u2CEAF\uF900-\uFAFF\u3000-\u303F]+$/,
  // eslint-disable-next-line
  noEmoji: /^[A-Za-z0-9\s\.\,\“\”\‘\’\'\"\Ꞌ\"\′\″\‵\‶\!\@\#\$\%\^\&\*\(\)\_\+\=\-\{\}\[\]\|\\\:\;\"\'\<\>\?\,\.\/\'\~\`\(\)\“\”\：\；\!\？\,\[\]\‘\’\u3000\u3400-\u4DBF\u4E00-\u9FFF\u2A700–\u2B73F\u2B740–\u2B81F\u2B820–\u2CEAF\uF900-\uFAFF\u3000-\u303F]+$/,
  digits: /^[0-9]*$/
};

export default Regex;
